// @ts-expect-error
export const IS_EXTENSION = typeof window.chrome?.extension === 'object';
